import { render, staticRenderFns } from "./TextSection.vue?vue&type=template&id=195dab08&scoped=true&"
import script from "./TextSection.vue?vue&type=script&lang=ts&"
export * from "./TextSection.vue?vue&type=script&lang=ts&"
import style0 from "./TextSection.vue?vue&type=style&index=0&id=195dab08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195dab08",
  null
  
)

export default component.exports